export default __webpack_public_path__ + "static/media/15.6d3b0b7c.pdf";